import { useLayoutEffect, useState } from 'react';
function readBorderRadius(el) {
    const raw = window.getComputedStyle(el).borderRadius;
    const parsed = parseFloat(raw);
    if (Number.isNaN(parsed)) return null;
    return parsed;
}
export function useSpotlightTargetMeasurement(targetId) {
    const [measurement, setMeasurement] = useState(null);
    useLayoutEffect(()=>{
        let frame = 0;
        let observer = null;
        let mutationObserver = null;
        let cancelled = false;
        const measure = ()=>{
            const el = document.getElementById(targetId);
            if (el == null) {
                setMeasurement(null);
                return null;
            }
            const rect = el.getBoundingClientRect();
            const borderRadius = readBorderRadius(el);
            setMeasurement((prev)=>{
                if (prev != null && prev.rect.left === rect.left && prev.rect.top === rect.top && prev.rect.width === rect.width && prev.rect.height === rect.height && prev.borderRadius === borderRadius) {
                    return prev;
                }
                return {
                    rect,
                    borderRadius
                };
            });
            return el;
        };
        const scheduleMeasure = ()=>{
            cancelAnimationFrame(frame);
            frame = requestAnimationFrame(()=>{
                if (!cancelled) measure();
            });
        };
        const observe = (el)=>{
            observer = new ResizeObserver(scheduleMeasure);
            observer.observe(el);
        };
        const initial = measure();
        if (initial != null) {
            observe(initial);
        } else {
            mutationObserver = new MutationObserver(()=>{
                const el = measure();
                if (el != null) {
                    observe(el);
                    mutationObserver === null || mutationObserver === void 0 ? void 0 : mutationObserver.disconnect();
                    mutationObserver = null;
                }
            });
            mutationObserver.observe(document.body, {
                childList: true,
                subtree: true
            });
        }
        const scrollOptions = {
            capture: true,
            passive: true
        };
        window.addEventListener('resize', scheduleMeasure, {
            passive: true
        });
        window.addEventListener('scroll', scheduleMeasure, scrollOptions);
        return ()=>{
            cancelled = true;
            cancelAnimationFrame(frame);
            observer === null || observer === void 0 ? void 0 : observer.disconnect();
            mutationObserver === null || mutationObserver === void 0 ? void 0 : mutationObserver.disconnect();
            window.removeEventListener('resize', scheduleMeasure);
            window.removeEventListener('scroll', scheduleMeasure, scrollOptions);
        };
    }, [
        targetId
    ]);
    return measurement;
}
